import ExpandMoreIcon from "@material-ui/icons/ExpandMoreRounded";
import React from "react";
import { MenuItem, Box } from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import InternalRoutes from "../../../../Shared/Constants/InternalRoutes";
import ExternalRoutes from "../../../../Shared/Constants/ExternalRoutes";
import Castle from "Shared/Analytics/CastleProvider";
import { GearIcon, LogoutDoorIcon } from "Components/Icons";
import LocalStorageKeys from "Shared/Constants/LocalStorageKeys";
import useStyles from "./styles";
import TopNavMenu from "../TopNavMenu/TopNavMenu";
import { DPSpacer, DPLink } from "Components/DP";

const EmployerMenu = () => {
  const classes = useStyles();
  const { employer, permissions } = usePartnerConfig();

  const onLogoutClick = () => {
    Castle.reset();
    localStorage.removeItem(LocalStorageKeys.userTokenKey);
    const logOutHref = ExternalRoutes.logout;
    window.location.assign(logOutHref);
  };

  const menuItems = [];

  if (permissions.canUpdateNotificationSettings) {
    menuItems.push(
      <MenuItem className={classes.menuItem}>
        <DPLink className={classes.link} to={InternalRoutes.userSettings}>
          <GearIcon className={classes.icon} />
          Settings
        </DPLink>
      </MenuItem>
    );
  }

  menuItems.push(
    <MenuItem className={classes.menuItem} onClick={onLogoutClick}>
      <Box alignItems="center" display="flex" p={2}>
        <LogoutDoorIcon className={classes.icon} />
        Logout
      </Box>
    </MenuItem>
  );

  return (
    <TopNavMenu menuItems={menuItems} menuName="providerMenu">
      <Box flexWrap="nowrap">{`Hi, ${employer.firstName}`}</Box>
      <DPSpacer />
      <ExpandMoreIcon color="inherit" />
    </TopNavMenu>
  );
};

export default EmployerMenu;
